<template>
  <div class="leftres">
    <div>
      <div class="inputtop">
        <template v-for="(item , index) of formdata">
          <Commondropdownlist :key="index" ref="roleselect" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
        </template>
        <CommonBtngroup :qhide="false" :show="false" @reset="reset" @select="select"></CommonBtngroup>
      </div>
      <div class="TableBox" style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);  margin: 10px 0px 50px;background-color: #FFFFFF;">
        <Rolemanagementtable :tableData="tableData" :total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></Rolemanagementtable>
      </div>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../components/commongroup.vue'
import Rolemanagementtable from '../rolemanagement/components/rolemanagementtable.vue'
import { UserRolesList } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    Rolemanagementtable
  },
  data() {
    return {
      formdata: [
        {
          inputdata: '',
          title: '角色名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '480px'
        }
      ],
      tableData: [],
      total: 1,
      pageIndex: 1,
      pageSize: 20,
      roleName: ''
    }
  },
  mounted() {
    this.userRolesList()
  
  },
  methods: {
    // 查询
    async userRolesList() {
      let {
        code,
        data
      } = await UserRolesList({
        roleName: this.roleName,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
      this.formdata[0].inputdata = this.roleName
      //console.log("data", data)
      if (code == 0) {
        if (data.data) {
          this.tableData = data.data
          this.total = data.count
        }
      }
    },
    reset() {
      this.$refs.roleselect.map((item, index) => {
        item.modelvalue = ''
      })
    },
    select() {
      this.pageIndex = 1
      this.roleName = this.$refs.roleselect[0].modelvalue
      this.userRolesList()
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.userRolesList()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageIndex = 1
      this.userRolesList()
    },
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 24px;
}
</style>